module.exports = {
	"notification.message": "Wix.com wykorzystuje pliki cookies, abyś mógł czerpać maksimum przyjemności.",
	"notification.got.it": "Rozumiem",
	"notification.more.info": "Czytaj Dalej",
	"notification.got.it.arrow": "arrow icon"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_pl.json
// module id = 57
// module chunks = 0